import React, { Fragment } from 'react';
import { string } from 'prop-types';
import { useIntl } from 'react-intl';
import { getUnitTrans } from 'utils';

export default function PerUnit({ value }) {
    const intl = useIntl();
    const unitMessage = getUnitTrans(value);
    const unit = unitMessage.id ? intl.formatMessage(unitMessage) : unitMessage;
    return (
        <Fragment>
            <span className="prices_slash"> / </span>
            <span className="prices__unit">{unit}</span>
        </Fragment>
    );
}

PerUnit.propTypes = {
    value: string.isRequired,
};
